document.addEventListener('click', function(e){
  const s = e.target && e.target.closest ? e.target.closest('summary') : null
  if(!s) return
  const d = s.parentElement
  if(!d || d.tagName !== 'DETAILS') return
  const group = d.closest('[data-ei-accordion]')
  if(!group) return
  if(!d.open) return
  group.querySelectorAll('details').forEach(function(x){
    if(x !== d) x.open = false
  })
})
